/**
 * 表单项不允许为空验证器
 * @param {Object} rule 表单规则
 * @param {*} value 值
 * @param {Function} callback 回调
 */
export function notEmptyValidator(rule, value, callback) {
  /**
   * 错误回调
   * @returns {void}
   */
  const errorCallback = () => {
    callback(new Error(rule.message || '不能为空'));
  };

  /**
   * 如果value是数组类型，则判断数组是否为空
   */
  if (Object.prototype.toString.call(value) === '[object Array]') {
    value.length > 0 ? callback() : errorCallback();
    return;
  }

  /**
   * 如果value是对象类型，则判断对象是否为空
   */
  if (Object.prototype.toString.call(value) === '[object Object]') {
    Object.keys(value).length > 0 ? callback() : errorCallback();
    return;
  }

  /**
   * 其他类型
   */
  if (value !== null && value !== undefined && value !== '') {
    callback();
  } else {
    errorCallback();
  }
}

/**
 * 使用正则表达式替换所有正则表达式的特殊字符
 * @param {string} input
 * @returns {string}
 */
function escapeRegExp(input) {
  // 这包括了 $ ^ . * + ? ( ) [ ] { } | \ /
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * 验证是否包含某个字符
 * @param {string} input 输入值
 * @param {string} special_char 字符
 * @returns {boolean}
 */
export function containsSpecialChar(input, special_char) {
  const escaped_special_char = escapeRegExp(special_char);
  const regex = new RegExp(escaped_special_char, 'g');
  return regex.test(input);
}

/**
 * 表单项不包含特殊字符验证器
 * @param {Object} rule 表单规则
 * @param {string} value 值
 * @param {Function} callback 回调
 */
export function notContainsSpecialCharValidator(rule, value, callback) {
  if (!containsSpecialChar(value, rule.special_char)) {
    callback();
  } else {
    callback(new Error(rule.message || '不能为空'));
  }
}

/**
 * 创建计划名称限制规则
 * @param {string} delimiter 分隔符
 * @returns {Object}
 */
export function createCampaignNameSpecialRule(delimiter) {
  return {
    required: true,
    validator: notContainsSpecialCharValidator,
    message: `计划名称不能包含敏感字符 “${delimiter}” `,
    trigger: ['change'],
    special_char: delimiter,
  };
}
